import { InputCheckbox } from "@brg/input/dist/checkbox/InputCheckbox";
import { Colors, FInter, FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";
import { Input } from "@brg/input";
import { LayoutConst } from "core";

export const ErrorMessage = styled.span`
    // color: ${({ theme }) => theme.projectEdit.textTips};
    color: red;
    font-size: 11px;
    line-height: 13px;
    font-family: 'Inter';
    padding-top: 8px;
`;

export const LegendBadge = styled.span`
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 16px;
    color: ${(p) => p.theme.sendProjectsModal.label};
`;

export const Container = styled(FlexBox)`
    width: 100%;
    form > div:not(:last-child) {
        margin-bottom: 24px; 
    }

    .phone-input {
        width: 100%;
        max-width: none;
        border: 1px solid transparent;
    }
    
    .phone-button {
        border: 3px solid transparent;
    }

    .checkbox-label {
        font-size: 15px;
        line-height: 20px;
        color: ${Colors.galBlack47};

        a {
            text-decoration: underline;
            color: ${Colors.galBlack47};
        }
    }
`;  

export const CommonCheckbox = styled(Input.Checkbox)`
    div {
        background-color: transparent;
    border: 1px solid #909090;
    border-radius: 3px;
    max-width: 24px !important;
    min-width: 24px !important; 
    position: relative;
    margin-left: 0;
    height: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
    :hover {
        background: transparent;
    }
}

`;

export const FlexInputContainer = styled(FlexBox)`
    flex-flow: row;
    @media(max-width: ${LayoutConst.screen.m}px) {
        flex-flow: column
    }
`;

export const LabelRedStar = styled(FInter.SmallText)<{ hide?: boolean }>`
font-family: Inter;
font-weight: 400;
font-size: 15px;
line-height: 20px;
letter-spacing: -2%;

margin-left: 4px;
color: ${Colors.redFailed};

${p => p?.hide ? css` opacity: 0;` : null};
`;import { InputCheckbox } from "@brg/input/dist/checkbox/InputCheckbox";
import { Colors, FInter, FlexBox } from "@brg/ui";
import styled, { css } from "styled-components";
import { Input } from "@brg/input";
import { LayoutConst } from "core";

export const ErrorMessage = styled.span`
    // color: ${({ theme }) => theme.projectEdit.textTips};
    color: red;
    font-size: 11px;
    line-height: 13px;
    font-family: 'Inter';
    padding-top: 8px;
`;

export const LegendBadge = styled.span`
    white-space: nowrap;
    display: inline-block;
    margin-bottom: 16px;
    color: ${(p) => p.theme.sendProjectsModal.label};
`;

export const Container = styled(FlexBox)`
    width: 100%;
    form > div:not(:last-child) {
        margin-bottom: 24px; 
    }

    .phone-input {
        width: 100%;
        max-width: none;
        border: 1px solid transparent;
    }
    
    .phone-button {
        border: 3px solid transparent;
    }

    .checkbox-label {
        font-size: 15px;
        line-height: 20px;
        color: ${Colors.galBlack47};

        a {
            text-decoration: underline;
            color: ${Colors.galBlack47};
        }
    }
`;  

export const CommonCheckbox = styled(Input.Checkbox)`
    div {
        background-color: transparent;
    border: 1px solid #909090;
    border-radius: 3px;
    max-width: 24px !important;
    min-width: 24px !important; 
    position: relative;
    margin-left: 0;
    height: 24px !important;
    min-height: 24px !important;
    max-height: 24px !important;
    :hover {
        background: transparent;
    }
}

`;

export const FlexInputContainer = styled(FlexBox)`
    flex-flow: row;
    @media(max-width: ${LayoutConst.screen.m}px) {
        flex-flow: column
    }
`;

export const LabelRedStar = styled(FInter.SmallText)<{ hide?: boolean }>`
font-family: Inter;
font-weight: 400;
font-size: 15px;
line-height: 20px;
letter-spacing: -2%;

margin-left: 4px;
color: ${Colors.redFailed};

${p => p?.hide ? css` opacity: 0;` : null};
`;